import { Alert } from './Alert'
import { action, observable, makeObservable } from 'mobx'

/**
 * Manages App Notifications (the ones rendered inside the app, not related to Desktop Notifications).
 */
export default class AlertsController {
  /**
   * The visible alerts.
   */
  @observable alerts: Alert[] = []

  constructor() {
    makeObservable(this)
  }

  /**
   * Creates a new Alert.
   */
  @action.bound
  newAlert(): Alert {
    const alert: Alert = new Alert(
      () => this.addAlert(alert),
      () => this.removeAlert(alert),
    )

    return alert
  }

  /**
   * Adds the alert to the list.
   *
   * @param alert
   */
  @action.bound
  private addAlert(alert: Alert) {
    this.alerts.unshift(alert)
  }

  /**
   * Removes the alert from the list.
   *
   * @param alert
   */
  @action.bound
  private removeAlert(alert: Alert) {
    const idx = this.alerts.indexOf(alert)
    if (idx === -1) {
      return
    }

    this.alerts.splice(idx, 1)
  }
}
